class TabSwitcher extends HTMLElement {
  connectedCallback() {
    this.pills = Array.from(this.querySelectorAll('[data-tab-pill]'));
    this.panels = Array.from(this.querySelectorAll('[data-tab-panel]'));

    this.pills.forEach((pill) => {
      pill.addEventListener('click', () => this.select(pill.dataset.tabPill));
    });
  }

  select(id) {
    this.pills.forEach((pill) => {
      const active = pill.dataset.tabPill === id;
      pill.classList.toggle('is-active', active);
      pill.setAttribute('aria-selected', String(active));
    });

    this.panels.forEach((panel) => {
      panel.hidden = panel.dataset.tabPanel !== id;
    });

    // A tab that has not been opened yet holds its grid in a <template>
    // (sections/product-section.liquid). Copy it out, in place, the first time.
    const lazy = this.panels.find((panel) => panel.dataset.tabPanel === id)?.querySelector(':scope > template[data-tab-lazy]');
    if (lazy) lazy.replaceWith(lazy.content);

    // Put the tab that was just opened at the front of the image queue
    // (assets/idle-image-queue.js), in case it has not reached it yet.
    const opened = this.panels.find((panel) => panel.dataset.tabPanel === id);
    if (opened && window.IdleImageQueue) window.IdleImageQueue.bump(opened);
  }
}

if (!customElements.get('tab-switcher')) {
  customElements.define('tab-switcher', TabSwitcher);
}
